export default __webpack_public_path__ + "static/media/TechMang.69b320b4.jpg";